import { useAsyncEffect, useLockFn } from "ahooks";
import { useState } from "react";

/**
 * Custom hook to fetch an image from a given URL and return its data URL.
 * 
 * @param {string} url - The URL of the image to fetch.
 * @param {any[]} reloadDeps - Dependencies array to control when the effect should re-run.
 * @returns {string} - The data URL of the fetched image.
 */
export function useGetImage(url: string, reloadDeps: any[] = []) {
    const [imageDataUrl, setImageDataUrl] = useState("");

	useAsyncEffect(useLockFn(async () => {
        if (!url) return;
        
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: { 'Accept': 'image/*' },
            });
            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => setImageDataUrl(reader.result as string);
            reader.readAsDataURL(blob);
        } catch (error) {}
    }), [...reloadDeps, url]);

    return imageDataUrl;
}